import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { ADDON_META, ADDON_DETAILS } from "@/lib/addons";

export function useAddonPrices() {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/addons/public").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  return info;
}

const from = (k, p) => ({ wr: `from $${p.wr_hour}/hr`, rr: `from $${p.rr_hour}/hr`, ride: `from $${p.school_trip}/trip`, escort: `$${p.escort}` }[k]);

export function AddonsGrid({ info, onAdd, dark = false, addLabel }) {
  const [more, setMore] = useState(null);
  if (!info) return null;
  const details = ADDON_DETAILS(info.prices, info.member_discount_pct);
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="addons-grid">
        {Object.entries(ADDON_META).map(([k, m]) => {
          const I = m.icon;
          const off = !info.availability[k]?.enabled;
          return (
            <div key={k} className={`rounded-3xl p-5 border-2 flex flex-col ${dark ? "bg-white/5 border-white/10" : "bg-white border-slate-100"}`} data-testid={`addon-card-${k}`}>
              <div className="flex items-center gap-3">
                <span className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0" style={{ background: `${m.color}22` }}><I className="w-7 h-7" style={{ color: m.color }} /></span>
                <div><p className={`font-display font-extrabold ${dark ? "text-white" : "text-navy"}`}>{m.name}</p>
                  <p className={`text-xs ${dark ? "text-white/60" : "text-slate-500"}`}>{m.sub}</p></div>
              </div>
              <p className="font-display font-black text-xl mt-3" style={{ color: m.color }} data-testid={`addon-from-${k}`}>{from(k, info.prices)}</p>
              {off && <p className="text-xs text-coral font-bold mt-1">THIS SERVICE IS NOT AVAILABLE AT THIS TIME</p>}
              <div className="flex gap-2 mt-4">
                <Button variant="outline" size="sm" className={`rounded-full ${dark ? "bg-transparent text-white border-white/30" : ""}`} onClick={() => setMore(k)} data-testid={`addon-learn-${k}`}>LEARN MORE</Button>
                {onAdd ? <Button size="sm" className="rounded-full bg-gold text-navy font-bold" onClick={() => onAdd(k)} data-testid={`addon-add-${k}`}>{addLabel || m.cta}</Button>
                  : <Link to={`/dashboard/daytime?addon=${k}`}><Button size="sm" className="rounded-full bg-gold text-navy font-bold" data-testid={`addon-add-${k}`}>{m.cta}</Button></Link>}
              </div>
            </div>
          );
        })}
      </div>
      <Dialog open={!!more} onOpenChange={(o) => !o && setMore(null)}>
        <DialogContent className="sm:max-w-md" data-testid="addon-learn-dialog">
          {more && <>
            <DialogHeader><DialogTitle className="font-display text-navy">{ADDON_META[more].name}</DialogTitle></DialogHeader>
            <p className="text-sm italic text-slate-600">“{ADDON_META[more].msg}”</p>
            <ul className="text-sm text-slate-700 space-y-1">{details[more].map((d) => <li key={d}>• {d}</li>)}</ul>
            <p className="text-xs text-slate-400">Every request is confirmed by our team before it's final.</p>
            {onAdd && <Button className="rounded-full bg-gold text-navy font-bold" onClick={() => { const k = more; setMore(null); onAdd(k); }} data-testid="addon-learn-add">{addLabel || ADDON_META[more].cta}</Button>}
          </>}
        </DialogContent>
      </Dialog>
    </>
  );
}
